const RECURRENCE = ({ permissionIsEnabled, componentIsEnabled, routeName }) => {
  return {
    key: 'recurrence',
    label: 'sidemenu.recurrence',
    showSection:
      (permissionIsEnabled('plan:search') &&
        componentIsEnabled('sidemenu', 'plans')) ||
      (permissionIsEnabled('subscription:search') &&
        componentIsEnabled('sidemenu', 'subscriptions')) ||
      (permissionIsEnabled('invoice:search') &&
        componentIsEnabled('sidemenu', 'invoices')),
    items: {
      plans: {
        label: 'sidemenu.submenu.recurrence.plans',
        showItem:
          permissionIsEnabled('plan:search') &&
          componentIsEnabled('sidemenu', 'plans'),
        active: routeName === 'plans' || routeName === 'plansDetail'
      },
      subscriptions: {
        label: 'sidemenu.submenu.recurrence.subscriptions',
        showItem:
          permissionIsEnabled('subscription:search') &&
          componentIsEnabled('sidemenu', 'subscriptions'),
        active:
          routeName === 'subscriptions' || routeName === 'subscriptionsDetail'
      },
      invoices: {
        label: 'sidemenu.submenu.recurrence.invoices',
        showItem:
          permissionIsEnabled('invoice:search') &&
          componentIsEnabled('sidemenu', 'invoices'),
        active: routeName === 'invoices' || routeName === 'invoicesDetail'
      }
    }
  }
}

export default RECURRENCE
